import {createSelector} from 'reselect';
import {getIssuesCollection} from './issuesCollection-selectors';
import isEmpty from 'lodash/isEmpty';
import i18n from '../../utils/i18n';
import {issuesSortStatus} from '../../constants/status-types';
import {getUrn} from '../../utils/issues-helpers';
import {getConfiguration, getDocumentCollection} from './configuration-selectors';
import {getChecklistDetailHelper} from '../../utils/checklist-helper';

export const getCurrentPreviewIssueId = state => state.currentPreviewIssueId;

export const getChecklistCollection = createSelector(
  getConfiguration,
  configuration => configuration.checklist
);

export const getCurrentPreviewIssueWrapper = createSelector(
  getIssuesCollection,
  getCurrentPreviewIssueId,
  (collection, issueId) => collection[issueId] || Object.freeze({})
);

export const getCurrentPreviewIssueAttributes = createSelector(
  getCurrentPreviewIssueWrapper,
  ({attributes}) => attributes || Object.freeze({})
);

export const getCurrentPreviewIssueChannelItemsWrapper = createSelector(
  getCurrentPreviewIssueWrapper,
  ({channelItems}) => channelItems || Object.freeze({})
);

export const getCurrentIssuePreviewStatusOptions = createSelector(
  getCurrentPreviewIssueAttributes,
  issue => {
    if (isEmpty(issue)) {
      return [];
    }
    const currentStatus = issue.status;
    const permittedStatuses = issue.permittedStatuses;
    const statusLabels =
      i18n.getResource(i18n.language, 'translation', 'status') || i18n.getResource('en', 'translation', 'status');
    const statusDescriptions =
      i18n.getResource(i18n.language, 'translation', 'qualityIssuesStatusDescription') ||
      i18n.getResource('en', 'translation', 'qualityIssuesStatusDescription');
    const statuses = permittedStatuses.includes(currentStatus)
      ? permittedStatuses
      : [currentStatus].concat(permittedStatuses);
    return statuses.sort(issuesSortStatus).map(status => ({
      value: status,
      label: statusLabels[status],
      description: statusDescriptions[status] || '',
      colorClassName: `IssueStatus__${status}`
    }));
  }
);

export const getCurrentPreviewIssueIsUpdating = createSelector(
  getCurrentPreviewIssueWrapper,
  ({updating}) => updating
);

export const getCurrentPreviewIssueDocument = createSelector(
  getCurrentPreviewIssueAttributes,
  getDocumentCollection,
  (issue, documentCollection) => documentCollection[getUrn(issue)]
);

export const getChecklistDetail = createSelector(
  getIssuesCollection,
  getCurrentPreviewIssueId,
  getChecklistCollection,
  (collection, issueId, checlistCollection) => getChecklistDetailHelper(collection[issueId], checlistCollection)
);
